import React, { FC, useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { UiRoutes } from '../lib/constants';
import { getClientSecretKeyFromStore } from '../lib/helper';
import SomethingWentWrong from '../screens/Products/Plural/SomethingWentWrong';
import {
  clearRedirectAfterLoginPath,
  getRedirectAfterLoginPath,
} from './redirectAfterLogin';

const OpenRoute: FC<{
  component: FC;
  path: string;
  exact?: boolean;
  loginState;
}> = (props) => {
  const { path, exact } = props;
  const location = useLocation();

  const clientSecretKey = getClientSecretKeyFromStore();
  const { isUserAuthenticated, selectedProduct, isPartnerMerchant} =
    props.loginState;
  const isAdmin = useSelector(
    (state: any) => state?.loginReducer.loginState.isAdmin
  );

  useEffect(() => {
    if (clientSecretKey) {
      const loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);
        if (!isScriptExist) {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      };
      // load the script by passing the URL
      loadScriptByURL(
        'recaptcha-key',
        `https://www.google.com/recaptcha/enterprise.js?render=${clientSecretKey}`,
        function () {}
      );
    }
  }, [clientSecretKey]);

  useEffect(() => {
    const ele = document.getElementsByClassName('grecaptcha-badge')[0];
    if (ele?.hasAttribute('hidden')) {
      ele.removeAttribute('hidden');
    }
  }, []);

  const redirectAfterLoginPath = getRedirectAfterLoginPath(location);
  const redirectToSavedPath = () => {
    clearRedirectAfterLoginPath();
    return <Redirect to={redirectAfterLoginPath as string} />;
  };

  return !isUserAuthenticated ? (
    <Route path={path} exact={exact} component={props.component} />
  )
   : isPartnerMerchant ? (
    <Redirect to={UiRoutes.PARTNER_SUMMARY} />
  ) : !isAdmin && redirectAfterLoginPath ? (
    redirectToSavedPath()
  ) : selectedProduct ? (
    selectedProduct?.name === 'EDGE' ? (
     <Redirect to={UiRoutes.EDGE_OVERVIEW} />
    ) : selectedProduct?.name === 'PAYOUT' ? (
      <Redirect to={UiRoutes.INDIVIDUAL_PAYOUTS} />
    ) : (
      <Redirect to={UiRoutes.OVERVIEW} />
    )
  ) : isAdmin && !props.loginState.MerchantId ? (
    <Redirect to={UiRoutes.OVERVIEW} />
  ) : (
    <SomethingWentWrong />
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
});

export default connect(mapStateToProps)(OpenRoute);
